import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import WebSocket from '../../../WebSocket';

const ExpensesWebsocketConnection = ({ onMessage }) => {
  const [enabledWebSocketConnection, setEnabledWebSocketConnection] = useState(false);

  const isAnyInteractionOpen = useSelector((state) => {
    const isOpenAgentChat = state.agent?.agentChatProps?.open;
    const isOpenAddExpenseModal = state.expense?.addExpenseModalProps?.open;
    return Boolean(isOpenAgentChat || isOpenAddExpenseModal);
  });

  useEffect(() => {
    if (isAnyInteractionOpen && !enabledWebSocketConnection) setEnabledWebSocketConnection(true);
  }, [isAnyInteractionOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!enabledWebSocketConnection) return null;

  return <WebSocket onMessage={onMessage} />;
}

ExpensesWebsocketConnection.propTypes = {
  onMessage: PropTypes.func,
}

export default ExpensesWebsocketConnection;
